import http from '@/api/common'

export default {
  lookup (data, config) {
    return http.post('lookup/ByKey', `"${data}"`, config)
  },
  lookups (data, config) {
    return http.post('lookup/ByKeys', data, config)
  },
  upsertLookup (data) {
    return http.post('lookup/Upsert', data)
  },
  upsertProduct (data) {
    return http.post('c/Business/UpsertProduct', data)
  },
  getTimeZones () {
    return http.get('lookup/TimeZones')
  },
  getDistributors () {
    return http.get('lookup/Distributors')
  },
  getSalesReps () {
    return http.get('lookup/SalesReps')
  },
  getVehicleManufacturers () {
    return http.get('lookup/VehicleManufacturers')
  },
  getInsuranceCompanies () {
    return http.get('lookup/InsuranceCompanies')
  },
  getProducts () {
    return http.get('lookup/Products')
  },
  getStates () {
    return http.get('lookup/StateProvince')
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/lookup.js